import React from "react"
import Password from "./src/components/password.js"

export const wrapRootElement = ({ element }) => {
  return <Password>{element}</Password>
}